export class Company {
    companyId: number;
    companyName: string;
    marketNumber: string;
    convertedMarketNumber: number;
}
